const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhysicalMedicineRehab(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD2B0",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M5.491,18.683c0,0,4.157-1.847,4.228,0.912 h1.034l-0.596,2.57l-1.918,0.024l-1.267,0.189L5.823,22.39c0,0-0.497-0.107-0.699-0.462c-0.201-0.355-0.403-0.142-0.367-0.959 s0.047-1.089,0.047-1.089s0.272-0.616,0.308-0.687C5.147,19.121,5.491,18.683,5.491,18.683z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M20,19l-6,0.2l0.1-1.382l-1.374-0.924 L12.9,14.2c0.2-1.7,0.9-1.7,0.9-1.7l2.8-1h1.7l2.8,1c0,0,0.9,0.3,1.5,1.5l1.5,2.6l-3.2,1.1v1.5L15.1,19"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD2B0",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M17.5,12.4L17.5,12.4c-0.6,0-1.1-0.1-1.1-0.7 v-1.2c0-0.6,0.5-1.1,1.1-1.1l0,0c0.6,0,1.1,0.5,1.1,1.1v1.2C18.6,12.3,18.1,12.4,17.5,12.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B5889",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M28.8,20.9l-11.1-0.3c-0.1,0-0.7,0.5-0.7,0.6 l0.1,2.4h2.4l0,0h9.3V20.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B5889",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M28.8,15.9L21.4,17l-3.5,2.8 c-0.1,0-0.3,0.8-0.3,0.9l1.3,2l1.3-0.8l2.7-2.3l5.9-0.8V15.9z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5BA5ED",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M18.5,23.6V19h-6.4c0,0-1.9,0.3-2,1.7 c0,0-0.1,1.3,0.1,2.1c0,0-0.2,1,1.7,0.8H18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD2B0",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M19.4,21.7l1.4-0.1c0.2,0,0.3,0.1,0.4,0.2 c0.1,0.3,0.2,1,0,1.5c-0.1,0.2-0.3,0.2-0.4,0.2l-1.4-0.4c-0.2,0-0.3-0.2-0.3-0.4v-0.8C19,21.8,19.2,21.7,19.4,21.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5BA5ED",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M10.3,23.5L10.3,23.5C9.9,23,9.7,22.3,10,21.6 c0.3-0.8,0.9-0.7,2.1-0.7l7.8,0.2c0.1,0,0.2,0.2,0.2,0.3l-0.2,2.2h-9C10.6,23.7,10.4,23.6,10.3,23.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C355E"
    },
    d: "M6.2,23.1C6,23.1,5.9,23,5.7,23c0-0.9-0.2-1.4-0.2-2.3c0.1-0.1,0.1-0.5,0.2-0.7 c0,0.2,0.3,0.2,0.3,0.3c0.3,0.3,0.6,0.3,0.8,0.3C7,20.8,7,21,6.8,21.1s-0.4,0.1-0.5,0.1c0,0,0,0-0.1,0.1C6,21.4,5.9,21.6,6,21.7 C6.2,22,6.5,22,6.8,21.9c0.2-0.1,0.3-0.2,0.4-0.4c0.1-0.1,0.2-0.2,0.4-0.2c0.6,0,1.1,0.1,1.5,0.1c0.1,0,0.2,0.2,0.1,0.3 C8.8,22.2,7.7,23.3,6.2,23.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C355E"
    },
    d: "M5.7,23c0,0-2.3-0.6-2-3.1c0,0,0.1-1.7,1.9-2.1c0,0,1.4,0.6,0.7,1.9c0,0-0.5,0.9-0.2,1 c0.4,0.2-0.2,0.7-0.2,0.7l-0.1,0.4L6,22.3c0,0,0.1,0.2,0.1,0.3S5.7,23,5.7,23z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B5889",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M2.8,25.2l26-0.1v-1.2H8v-0.6H3.4 c-0.2,0-0.3,0.2-0.3,0.3v1.7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD2B0",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M19.34,17.529l1.4,0.4c0.2,0,0.3,0.2,0.3,0.3 c0,0.4,0,1-0.4,1.5c-0.1,0.1-0.3,0.2-0.5,0.1l-1.3-0.7c-0.1-0.2-0.2-0.4-0.1-0.6l0.2-0.8C18.94,17.629,19.139,17.529,19.34,17.529z"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    x1: 15.3,
    y1: 15.4,
    x2: 15.3,
    y2: 13.6
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    x1: 21.6,
    y1: 16.8,
    x2: 20.8,
    y2: 15.3
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD2B0",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M6.6,18.5l1.1-0.7c0,0,0.2-0.1,0.3,0.1 l0.2,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M8.7,19.2c0,0,0.4-0.4,0.2-0.8"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#5BA5ED",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    cx: 23.3,
    cy: 12.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    points: "24.5,12 23.8,12 23.8,11.3  22.9,11.3 22.9,12 22.2,12 22.2,12.9 22.9,12.9 22.9,13.6 23.8,13.6 23.8,12.9 24.5,12.9  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD2B0",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M19.95,8.694c0-0.37-0.189-0.669-0.422-0.669 c-0.015,0-0.028,0.011-0.043,0.014c-0.284-0.942-1.067-1.624-1.999-1.624c-0.935,0-1.72,0.686-2.001,1.632 c-0.023-0.006-0.043-0.021-0.066-0.021c-0.233,0-0.422,0.3-0.422,0.669c0,0.369,0.189,0.669,0.422,0.669 c0.004,0,0.008-0.004,0.012-0.004c0.224,1.047,1.056,1.828,2.055,1.828c0.999,0,1.831-0.781,2.055-1.828 C19.768,9.347,19.95,9.056,19.95,8.694z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C355E"
    },
    d: "M15.64,8.813l-0.486-0.576c-0.45-1.201,0.068-2.133,0.068-2.133c0.725-1.45,2.589-1.243,2.589-1.243 s1.553,0.207,2.071,1.45c0,0,0.715,1.679-0.604,2.303l-0.16-0.856c0,0-0.704-0.031-0.704-0.963c0,0-0.622,1.511-2.562,1.263 c0,0,1.028-1.333,1.442-1.126c0,0-0.416,1.223-1.555,1.12L15.64,8.813z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M17.7,8.4L18,9.5c0,0,0,0.2-0.2,0.3h-0.4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M17.1,10.4c0,0,0.5,0.2,0.8,0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M12.963,17.042c0,0-0.327,0.391,0.806,0.778l4.503,1.511c0.139,0.047,0.29-0.026,0.34-0.164 l0.782-2.153c0.051-0.14-0.021-0.294-0.16-0.346l-5.185-1.894l-0.999,1.07L12.963,17.042z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M12.717,16.955c0,0-0.098,0.627,1.035,1.014 l4.503,1.511c0.139,0.047,0.29-0.026,0.34-0.164l0.782-2.153c0.051-0.14-0.021-0.294-0.16-0.346l-4.501-1.675"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhysicalMedicineRehab);
export default __webpack_public_path__ + "static/media/physical_medicine_rehab.800ff0a7bb15b85a311e081835ba0548.svg";
export { ForwardRef as ReactComponent };